import React from 'react';
import './client.css'

const DeleteModal = ({ onClose, deleteCurrentUser }) => {
    return (
        <div className='modal_overlay' onClick={onClose}>
            <div
                className='modal_window'
                onClick={(e) => e.stopPropagation()} // Остановить всплытие
            >
                <h5 className='manrope-bold' style={{textAlign: 'center' }}>Вы уверены что хотите удалить аккаунт? Все данные будут удалены без возможности восстановления.</h5>

                <div style={{ display: 'flex', alignItems: 'center', gap: '15px'}}>
                    <div className='cancel_text manrope-bold' onClick={onClose}>
                        Отменить
                    </div>
                    <div className='delete_text manrope-bold' onClick={deleteCurrentUser}>
                        Удалить
                    </div>
                </div>
            </div>
        </div>
    );
};

export default DeleteModal;
